import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedTm.length !== 0)?_c(VSheet,{staticClass:"tm-pc-detail-frame",staticStyle:{"width":"100%"}},[(_vm.type === 'values')?_c('print-preview-values'):_vm._e(),(_vm.type === 'past')?_c('print-preview-past'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }